import { useCallback, useState } from 'react';
import { SerializedSmartLink } from 'fym-common/src/db/serializersTypes';
import { useUpdateSmartLinkMutation } from '../../../../redux/api/fymAPI';
import { isSuccessfulResult } from '../../../../redux/api/utils/isSuccessfulResult';
import { useEditorSaves } from '../saves/useEditorSaves';

export type PageSaveState = 'idle' | 'saving' | 'saved' | 'failed';

interface PageFields {
  name?: string;
  slug?: string;
  platformDomain?: string;
}

/**
 * Saves page fields of the draft (design a6). The PATCH replaces the whole version, so the name,
 * the slug, the theme and the background ride along with the field that changes.
 */
export function useSavePageFields(smartLink: SerializedSmartLink) {
  const [updateSmartLink] = useUpdateSmartLinkMutation();
  const [state, setState] = useState<PageSaveState>('idle');
  const saves = useEditorSaves();

  const save = useCallback(
    async (fields: PageFields): Promise<boolean> => {
      const { name, slug, theme, backgroundFile } = smartLink.recentSmartLinkVersion;
      setState('saving');
      const call = updateSmartLink({
        accountId: smartLink.accountId,
        smartLinkId: smartLink.id,
        name: fields.name ?? name,
        slug: fields.slug ?? slug,
        theme,
        backgroundFileId: backgroundFile?.id,
        platformDomain: fields.platformDomain,
      });
      const result = await (saves?.track(call, (answer) => !isSuccessfulResult(answer)) ?? call);
      const ok = isSuccessfulResult(result);
      setState(ok ? 'saved' : 'failed');
      return ok;
    },
    [saves, smartLink, updateSmartLink]
  );

  return { state, save };
}
